import { Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { permissions } from '../../permissions';
import { RolesComponent } from './roles/roles.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { AuthGuardService as AuthGuard} from './../../auth-guard.service';
import {FormComponent as RolesComponentForm} from './roles/form/form.component';


export const routes: Routes = [
    {
        path: 'rights/permissions',
        component: PermissionsComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.PERMISSION_READ]
            }
        }
    }, {
        path: 'rights/roles',
        component: RolesComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.ROLES_READ]
            }
        }
    }, {
        path: 'rights/roles/add',
        component: RolesComponentForm,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.ROLES_ADD]
            }
        }
    }, {
        path: 'rights/roles/edit/:name',
        component: RolesComponentForm,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.ROLES_EDIT]
            }
        }
    }
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/rights/rights.routing.ts